import { StyleSheet } from 'react-native';
import { useTheme, } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';

const RecruitmentPageCandidates = (props) => {
    const { colors } = useTheme();
    const styles = makeStyles(colors);
    const { t } = useTranslation();

    return (
        <></>
    )
}

const makeStyles = (colors) => StyleSheet.create({

})

export default RecruitmentPageCandidates; 